import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail } from "lucide-react";
import { useStore } from "@/context/StoreContext";

export const Footer = () => {
  const { config } = useStore();
  return (
    <footer className="bg-[#120A07] border-t border-[#3B251D] mt-20" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <img src="/brand/emblem.png" alt="SCHOKODALE" className="h-20 w-20 rounded-full object-cover ring-1 ring-[#D4AF37]/30 mb-3" />
          <span className="font-display text-2xl font-extrabold gold-gradient-text tracking-wider">SCHOKODALE</span>
          <p className="text-[#8C7B6E] text-xs tracking-[0.3em] mt-1">THE VALLEY OF CHOCOLATES</p>
          <p className="text-[#C8B8AB] text-sm mt-5 leading-relaxed max-w-xs">
            Master chocolatier confections and single-origin cacao, crafted for moments worth savouring.
          </p>
        </div>
        <div>
          <h4 className="eyebrow mb-4">Explore</h4>
          <ul className="space-y-3 text-sm text-[#C8B8AB]">
            <li><Link to="/shop" className="hover:text-[#D4AF37]">Explore Collection</Link></li>
            <li><Link to="/shop?collection=Festive Signature" className="hover:text-[#D4AF37]">Festive Collections</Link></li>
            <li><Link to="/gifting-guide" className="hover:text-[#D4AF37]">Gifting Occasion Guide</Link></li>
            <li><Link to="/customisation" className="hover:text-[#D4AF37]">Customisation</Link></li>
            <li><Link to="/gifting" className="hover:text-[#D4AF37]">Gifting & Corporate</Link></li>
            <li><Link to="/catalogue" className="hover:text-[#D4AF37]">Download Catalogue</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="eyebrow mb-4">Care</h4>
          <ul className="space-y-3 text-sm text-[#C8B8AB]">
            <li><Link to="/account" className="hover:text-[#D4AF37]">My Account</Link></li>
            <li><Link to="/account?tab=orders" className="hover:text-[#D4AF37]">Order History</Link></li>
            <li><Link to="/account?tab=wishlist" className="hover:text-[#D4AF37]">Wishlist</Link></li>
            <li><Link to="/shipping-delivery" data-testid="footer-shipping" className="hover:text-[#D4AF37]">Shipping & Delivery</Link></li>
            <li><Link to="/refund-cancellation" data-testid="footer-refund" className="hover:text-[#D4AF37]">Refund & Cancellation</Link></li>
            <li><Link to="/contact" data-testid="footer-contact" className="hover:text-[#D4AF37]">Contact Us</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="eyebrow mb-4">Connect</h4>
          <div className="flex gap-3">
            <a href={config.instagram_url || "https://instagram.com"} target="_blank" rel="noreferrer" data-testid="footer-instagram"
              className="h-10 w-10 rounded-full border border-[#3B251D] flex items-center justify-center text-[#D4AF37] hover:bg-[#D4AF37] hover:text-[#1A0F0B] transition">
              <Instagram size={18} />
            </a>
            <a href="mailto:schokodale@gmail.com" data-testid="footer-email"
              className="h-10 w-10 rounded-full border border-[#3B251D] flex items-center justify-center text-[#D4AF37] hover:bg-[#D4AF37] hover:text-[#1A0F0B] transition">
              <Mail size={18} />
            </a>
          </div>
          <p className="text-[#8C7B6E] text-xs mt-5">Secured checkout via Razorpay<br />UPI · Cards · Net Banking · Prepaid orders only</p>
          <p className="text-[#8C7B6E] text-xs mt-3">schokodale@gmail.com<br />+91 76229 27835</p>
        </div>
      </div>
      <div className="border-t border-[#3B251D] py-6 text-center text-xs text-[#8C7B6E]">
        <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 mb-3">
          <Link to="/privacy-policy" data-testid="footer-privacy" className="hover:text-[#D4AF37]">Privacy Policy</Link>
          <Link to="/terms-and-conditions" data-testid="footer-terms" className="hover:text-[#D4AF37]">Terms & Conditions</Link>
          <Link to="/refund-cancellation" className="hover:text-[#D4AF37]">Refund & Cancellation</Link>
          <Link to="/shipping-delivery" className="hover:text-[#D4AF37]">Shipping & Delivery</Link>
          <Link to="/contact" className="hover:text-[#D4AF37]">Contact Us</Link>
        </div>
        © {new Date().getFullYear()} SCHOKODALE — The Valley of Chocolates. All rights reserved.
      </div>
    </footer>
  );
};
